import WidthCalculatorFixed from "./width-columns"
import WidthCalculatorFull from "./width-full"
import GlistColumn, {GlistColumnType} from "./column"
import {GlistWidthMode} from "./const"
import GenericListModule from "../../generic-list-module";
import {GlistColumnConfig} from "../../types/column-config";

export const MIN_WIDTH = 40;            // min width for columns in GLIST
export const DND_HANDLE_COLUMN_WIDTH = 16; // according to css dnd-handle-column
export const ADD_COLUMN_WIDTH = 30;

const debug = false
// const debug = "ColumnsManager"

// Column types:
// field (default)
// actions (on hover)

export default class ListColumnsManager {

    public module               : GenericListModule
    public _columns             : GlistColumn[] = []
    public _visibleColumns      : GlistColumn[]
    public _byId                : {[key: fieldId] : GlistColumn} = {}

    public widthCalculator      : WidthCalculatorFixed | WidthCalculatorFull

    // this is current width for our glist in pixels
    public combinedWidth      = 500   // just a default value

    constructor(module:GenericListModule, columnsConfig:GlistColumnConfig[]) {
        this.module = module;

        // // we want to make sure we have all fields for columns (!)
        // // should we check access here too ?
        // this._columns = _.filter(columns, column=>{
        //     if (column.type==='actions') return true;
        //     return !!this.module.fields.get(column.fieldId);
        // })


        this._visibleColumns    = []
        this._byId              = {}

        // this is current width for our glist in pixels
        this.combinedWidth      = 500   // just a default value


        _.map(columnsConfig, (columnConfig)=>{
            this._addColumn(columnConfig)
        })

        this.widthCalculator = (this.module.widthMode === GlistWidthMode.FIXED)
            ? new WidthCalculatorFixed(this)
            : new WidthCalculatorFull(this)

        this.calculateCombinedWidth()

        gd.bus.subscribe("column:vertical-separator-resize-left", this, this.onResizeColumn);
    }

    // true if we need aggregation
    get haveAggregation(): boolean {

        const firstColumns = _.find(this._visibleColumns, (column)=>{
            return column.aggregateFunction !== null
        })

        return !!firstColumns

    }

    destructor() {
        gd.bus.unsubscribe(this)
    }

    onResizeColumn = (value:number, percentValue:number, data:any) => {
        switch (data.border) {
            case 'right':  this.resize(data.fieldId, value); break
            case 'left' :
                const columnsOrder : any[]  = _.map(this.allVisible(), (column:GlistColumn)=>{
                    return column.fieldId
                })

                let index           = _.indexOf(columnsOrder, data.fieldId)
                if (index !== -1) {
                    // get column to the left of this one and change its width
                    index--

                    // calculate new column width
                    const column = this.get(columnsOrder[index])

                    // @ts-ignore
                    debug && console.log(debug, 'onResizeColumn left', column.width, Math.round(value), column.width + Math.round(value), column)

                    // @ts-ignore
                    this.resize(column.fieldId, column.width + Math.round(value))
                }
                break
        }
    }

    all = () => this._columns

    public allVisible = () => {
        return this._visibleColumns
    }

    allVisibleFields = () => {
        return _.map(this._visibleColumns, (column: GlistColumn)=>{
            // @ts-ignore
            return this.module.fields.get(column.fieldId)
        })
    }

    _updateVisibleColumns = () => this._visibleColumns = _.filter(this._columns, column=>!column.isHidden)

    // get column by field id
    get (fieldId:fieldId) {
        return this._byId[fieldId]
    }


    add(fieldId:fieldId) {
        const field = this.module.fields.get(fieldId);

        debug && console.log(debug, 'add', fieldId, field, this.module.fields)

        // NEW
        this._addColumn({
            fieldId: fieldId
        })

        this._updateModule();
    }

    _addColumn(columnConfig:GlistColumnConfig) {
        const columnType = _.get(columnConfig,'type', GlistColumnType.FIELD)

        debug && console.log(debug, 'addColumn', columnType, columnConfig, this.module.fields)

        let field   = null

        if (columnType === GlistColumnType.ACTIONS) {

        } else {
            field = columnConfig.fieldId ? this.module.fields.get(columnConfig.fieldId) : null
            if (!field) {
                console.error("ERROR GLIST-COLUMNS-1 No field found", columnConfig.fieldId, columnConfig)
                return
            }
        }




        // TO-DO FUTURE: should we check access here too ???

        // old not needed
        // // we want to make sure we have all fields for columns (!)
        // // should we check access here too ?
        // this._columns = _.filter(columns, column=>{
        //     if (column.type==='actions') return true;
        //     return !!this.module.fields.get(column.fieldId);
        // })


        const column = new GlistColumn(field, columnConfig, this.module)

        // set isHidden for column if it is used as title additional field
        if (this.module.config.titleAdditionalFields &&
            this.module.config.titleAdditionalFields.includes(column.fieldId)) {
            column.isHidden = true
        }

        this._columns.push(column)
        this._updateVisibleColumns()

        // actions (GlistColumnType.ACTIONS) have no field
        if (field) {
            this._byId[field.fieldId] = column
        }
    }


    remove(id:fieldId) {
        const column = this.get(id);
        if (!column) {
            console.warn("#WARNING GLIST-9d84 no field", id, "found - > skip")
            return
        }

        if (column.fieldId === this.module.config.titleField) return;

        _.remove(this._columns, column=>column.fieldId === id)
        this._updateVisibleColumns()
        delete this._byId[id]

        this._updateModule();
    }

    toggleColumn(id:fieldId) {
        this.get(id) ? this.remove(id) : this.add(id);
    }

    move(sourceFieldId:fieldId, targetFieldId:fieldId, direction:'left'|'right') {
        if (targetFieldId) {
            const columnsIds = _.map(this._columns, column=>column.fieldId);
            const oldIndex = _.indexOf(columnsIds, sourceFieldId);
            let newIndex = _.indexOf(columnsIds, targetFieldId);

            switch (direction) {
                case 'left': if (oldIndex < newIndex) newIndex--; break; //move from left to right but to the left of target position
                case 'right': if (oldIndex > newIndex) newIndex++; break; //move from right to left but to the right of target position
            }

            gd.utils.moveInArrayMutate(this._columns, oldIndex, newIndex);
            this._updateVisibleColumns()

            this._updateModule();
        }
    }

    moveLeft(fieldId:fieldId) {
        if (fieldId) {
            const columnsIds = _.map(this._columns, column=>column.fieldId);
            const oldIndex = _.indexOf(columnsIds, fieldId);
            let newIndex = oldIndex - 1;

            // skip column if it is hidden
            while(newIndex > 0 && this._columns[newIndex].isHidden) {
                newIndex--
            }

            if (newIndex >= 0) {
                gd.utils.moveInArrayMutate(this._columns, oldIndex, newIndex)
                this._updateVisibleColumns()
                this._updateModule()
            }
        }
    }

    moveRight(fieldId:fieldId) {
        if (fieldId) {
            const columnsIds = _.map(this._columns, column=>column.fieldId);
            const oldIndex = _.indexOf(columnsIds, fieldId);
            let newIndex = oldIndex + 1;

            // skip column if it is hidden
            const maxIndex = this._columns.length + 1
            while(newIndex < maxIndex && this._columns[newIndex].isHidden) {
                newIndex++
            }

            if (newIndex <= columnsIds.length - 1) {
                gd.utils.moveInArrayMutate(this._columns, oldIndex, newIndex)
                this._updateVisibleColumns()
                this._updateModule()
            }
        }
    }

    // this is MANUAL resize hander
    resize(fieldId:fieldId, width:number) {
        const column = this.get(fieldId)

        if (!column) {
            throw Error("#kdjd90374 No column found fieldId="+fieldId)
        }

        // make sure it's not too small
        const minWidth = _.max([MIN_WIDTH, column?.minWidth])

        if (!_.isNil(minWidth)) {
            if (width < minWidth) {
                width = minWidth
            }
        }



        column.setManualWidth(width)

        // this._byId[fieldId].width = width < MIN_WIDTH ? MIN_WIDTH : width;
        this._updateModule();
    }

    resetWidth(fieldId:fieldId) {
        // const field = this.module.fields.get(fieldId);
        // this._byId[fieldId].width = field.defaultWidth ? field.defaultWidth : DEFAULT_WIDTH

        const column = this.get(fieldId)
        column.resetWidth()

        this._updateModule();
    }

    resetAllWidth() {
        _.mapKeys(this._byId, column => {
            column.resetWidth()
        })
        this._updateModule()
    }

    removeAllColumns() {
        _.remove(this._columns, (column)=>!column.isTitle)
        this._updateVisibleColumns()
        this._updateModule();
    }

    calculateCombinedWidth() {
        this.combinedWidth = this.widthCalculator.calculateTotalWidth()
    }

    getCombinedWidth() {return this.combinedWidth}

    _updateModule() {
        this.calculateCombinedWidth()
        this.module.onColumnsChanged()
        this.module.reRender()
    }


    toJSON() {
        return _.map(this._columns, column=>{
            return column.toJSON()
        })
    }
}
